// components/ImageModal.tsx
import React from 'react';

interface ImageModalProps {
    imageUrl: string;
    onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageUrl, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
            <div className="relative">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-red text-2xl font-bold"
                >
                    ×
                </button>
                <img
                    src={imageUrl}
                    alt="Enlarged view"
                    className="max-w-[90vw] max-h-[90vh] rounded-lg shadow-lg"
                />
            </div>
        </div>
    );
};

export default ImageModal;
